export const URL = 'URL'
export const FILE = 'FILE'
